import React, { useState, useEffect } from "react"
import { Button, Card, CardTitle, CardText } from "reactstrap"

const apiUrl = "https://admin.idexo.io/"

const AdminResources = () => {
    const [isLoading, setIsLoading] = useState(false)

    const [eventRules, setEventRules] = useState([])

    const handleRuleState = async (item) => {
        const rule_name = item.Name
        let action
        switch (item.State) {
            case "DISABLED":
                action = "enable"
                console.log("Trying enable rule: ", item.Name)
                break
            case "ENABLED":
                action = "disable"
                console.log("Trying disable rule: ", item.Name)
                break

            default:
                console.log("Invalid action!")
                break
        }

        if (rule_name && action) {
            console.log(rule_name, action)
            try {
                await fetch(apiUrl + `?path=cloudwatch&rule_name=${rule_name}&action=${action}`, {
                    method: "PATCH",
                    headers: { token: localStorage.jwtToken }
                }).then((_) => listEventBridgeRules())
            } catch (error) {
                console.log(error)
            }
        }
    }

    const listEventBridgeRules = async () => {
        await fetch(apiUrl + "?path=cloudwatch", {
            headers: { token: localStorage.jwtToken }
        })
            .then((res) => res.json())
            .then((data) => {
                console.log(data)
                if (data.error) {
                    alert("Things are not going your way, server says: " + data.error)
                } else if (data?.data?.data?.Rules) {
                    setEventRules(data?.data?.data?.Rules)
                }
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(setIsLoading(false))
    }

    useEffect(() => {
        if (!isLoading) {
            setIsLoading(true)
            listEventBridgeRules()
        }
        return () => {
            setIsLoading(false)
        }
    }, [])

    return (
        <div className="admin-page">
            <Card body>
                <CardTitle tag="h3">Resource Management</CardTitle>
                {eventRules.length > 0 ? (
                    <>
                        <CardTitle>Cloudwatch Event Rules</CardTitle>
                        <hr></hr>
                    </>
                ) : null}
                {eventRules.map((item) => {
                    return (
                        <>
                            <CardText>Name: {item.Name}</CardText>
                            <CardText>Description: {item.Description}</CardText>
                            <CardText>Schedule: {item.ScheduleExpression}</CardText>
                            <CardText>State: {item.State}</CardText>
                            <Button onClick={() => handleRuleState(item)} color={item.State === "ENABLED" ? "primary" : "secondary"}>
                                {item.State === "ENABLED" ? "DISABLE" : "ENABLE"}
                            </Button>
                            <hr></hr>
                        </>
                    )
                })}
            </Card>

            <hr></hr>
        </div>
    )
}

export default AdminResources
